<div class="absolute top-0 left-0 z-[9999] w-full h-full bg-black/30 backdrop-blur-sm flex justify-center items-center">
    <mat-spinner/>
</div>